import {configureStore} from "@reduxjs/toolkit";
import mapReducer from "./map";
import authReducer from "./auth";
import globalDataReducer from "./globalData";
import installationsReducer from "./installations";
import notificationMessagereducer from "./notification";
import deviceReducer from "./devices";
import triggersReducer from "./triggers";
import usersReducer from "./users";
import alarmsReducer from "./alarms";
import notesReducer from "./notes";
import dynamicTableReducer from "./dynamicTable"

export const store = configureStore({
    reducer: {
        map: mapReducer,
        auth: authReducer,
        globalData: globalDataReducer,
        installations: installationsReducer,
        notificationMessage: notificationMessagereducer,
        device: deviceReducer,
        triggers: triggersReducer,
        users:usersReducer,
        alarms:alarmsReducer,
        notes:notesReducer,
        dynamicTable:dynamicTableReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['table/locations/fulfilled'],
            },
        }),
})